import '../../css/public/ProgressBar.css';
interface Props {
  percentage: number;
}

const ProgressBar = (props: Props) => (
  <div className="progress-bar">
    <div
      className="progress-bar-filler"
      style={{
        width: `${props.percentage}%`,
      }}
    />
  </div>
);

export default ProgressBar;
